import { ReturnStatement } from '@angular/compiler';
import { Injector, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FacilityService } from 'src/app/core/services/facility.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ExportService } from '../../services/export.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { noFullWidthValidator, dynamicMaxLengthValidator } from 'src/app/core/utils/validation-functions';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-export-header-add',
  templateUrl: './export-header-add.component.html',
  styleUrls: ['./export-header-add.component.scss']
})
export class ExportHeaderAddComponent extends SessionBaseComponent implements OnInit {
  @ViewChild('declarDate') declarDate!: CalendarComponent;
  @ViewChild('flyDt1TimeZone') flyDt1TimeZone!: CalendarComponent;
  @ViewChild('flyDt2TimeZone') flyDt2TimeZone!: CalendarComponent;
  isSearchFormOpen: boolean;
  readonly viewPermissionCode = PermissionConstants.ExportDeclaration;
  currentLang: string = this.laasSetting.language;
  //form
  addForm: FormGroup;
  exportHeader: any;
  submitted: boolean;

  //options
  orgIdOptions: any[];
  forwarderOptions: any[];
  billObjectOptions: any[];
  billObjectTypeOptions: any[];
  shipMethodOptions: any[];
  docTypeOptions: any[];
  docType1Options: any[];
  currenyOptions: any[];
  exportCodeOptions: any[];
  consigneeOptions: any[];
  toCountryOptions: any[];
  toCityOptions: any[];
  isHkFacility: boolean;


  //dictionary
  consigneeDic: any[];
  docType1Dic: any[];
  columnNameMapping: {[key: string]: string} = {};

  //translate label : choose
  transLabel: any;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private facilityService: FacilityService,
    private exportService: ExportService,
    private commonDataService: CommonDataService,
    private dropdownOptionService: DropdownOptionsService,
  ) {
    super(injector);
    this.isSearchFormOpen = true;
    this.submitted = false;

    //options
    this.orgIdOptions = [];
    this.forwarderOptions = [];
    this.billObjectOptions = [];
    this.billObjectTypeOptions = [];
    this.shipMethodOptions = [];
    this.orgIdOptions = [];
    this.docTypeOptions = [];
    this.docType1Options = [];
    this.currenyOptions = [];
    this.exportCodeOptions = [];
    this.consigneeOptions = [];
    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.isHkFacility = true;

    //dictionary
    this.consigneeDic = [];
    this.docType1Dic = [];

    this.exportHeader = {
      docNo2:'',
      billObjectType: 'V',
      billObject:'76',
      currency:'USD'
    };

    this.addForm = this.fb.group({
      bookingForwarder:['', Validators.required],
      billObjectType:['', Validators.required],
      billObject:['76', Validators.required],
      docNo1:['', [Validators.required, noFullWidthValidator()]],
      docNo2:['', noFullWidthValidator()],
      docNo3:['', [Validators.required, noFullWidthValidator()]],
      docNo4:['', [Validators.required, noFullWidthValidator()]],
      docNo5:['', [Validators.required, noFullWidthValidator()]],
      shipMethod:['', Validators.required],
      orgId:['', Validators.required],
      consigneeKey:['', Validators.required],
      //consigneeName:['', Validators.required],
      exportDtTimeZone:['', Validators.required],
      docType:['', Validators.required],
      docType1:['', Validators.required],
      currency:['', Validators.required],
      exchangeRate: null,
      exportCode:'',
      exportType:'',
      exportAmount: [null, Validators.required],
      exportNtdAmount: null,
      freeOnBoardAmount: [null, Validators.required],
      freeOnBoardNtdAmount: null,
      freeOnBoardChargeAmount: null,
      mawbNo: ['', [Validators.maxLength(25)]],
      expressBill: ['', [Validators.required, Validators.maxLength(25)]],
      flyNo1: ['', [dynamicMaxLengthValidator(() => this.getFlyNo1MaxLength())]],
      flyNo2: ['', [Validators.maxLength(17)]],
      flyDt1TimeZone: '',
      flyDt2TimeZone:'',
      reference:'',
      changeConsigneeId:'',
      changeConsigneeName:'',
      bookingNo: ['', [Validators.maxLength(50)]],
      portOfLoadingDischargeName: ['', [Validators.maxLength(50)]],
      toCountry: '',
      toCity: '',
      containerNo: ['', [Validators.maxLength(200)]],
      consigneeCompany1: '',
      consigneeCompany2: '',
      consigneeAddress1: '',
      consigneeAddress2: '',
    });
    this.transLabel = ''
  }

  getFlyNo1MaxLength(): number {
    if (!this.addForm || !this.addForm.get('shipMethod')) { return 0; }
    const shipMethod = this.addForm.get('shipMethod');
    if (!shipMethod) { return 0; }
    const v = shipMethod.value;
    if (v === '4') {
      return 17;
    }
    return 35;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();


    console.log('isHkFacility before:', this.isHkFacility);

    // 等 API 回來
    const setting = await firstValueFrom(
      this.commonDataService.getAppCsmSetting('HKFacilitySetting')
    );
    // 設值
    this.isHkFacility = setting.appCsmSettingDetailList.some(
      (item: any) => item.setupValue === this.laasSetting.facility
    );
    console.log('isHkFacility after:', this.isHkFacility);

    // translate
    this.translateService.get('Common.Message.ChooseOption').subscribe((translated: string) =>{
      this.transLabel = this.translateService.instant('Common.Message.ChooseOption');
    });

    //options
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "").subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
        this.orgIdOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.facilityService.getForwarderOptions(this.laasSetting.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.forwarderOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      },
      complete: () => {

      }
    });

    this.facilityService.getBillObjectOptions(this.laasSetting.facility, this.exportHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.billObjectOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.billObjectTypeOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.shipMethodOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    forkJoin([
      this.facilityService.getDocTypeOptionsByFacilityCode('ALL'),
      this.facilityService.getDocTypeOptionsByFacilityCode(this.laasSetting.facility),
    ]).subscribe(([allOptions, facilityOptions]) => {
      this.docTypeOptions = [...facilityOptions.length ? facilityOptions : allOptions].map((x: any) => {
        const label = x.optionCode == x.optionDesc ? x.optionCode : `${x.optionCode}-${x.optionDesc}`;
        return {
          label,
          value: x.optionCode,
        };
      });
    });

    this.facilityService.getDocType1Options().subscribe({
      next: result => {
        this.docType1Dic = [...result];
        this.docType1Options = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.docType1Options.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currenyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.currenyOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.facilityService.getExportCodeOptions(this.laasSetting.facility).subscribe({
      next: result => {
        this.exportCodeOptions= [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.exportCodeOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.exportService.getCustomerOption().subscribe({
      next: result => {
        this.consigneeDic = [...result];
        this.consigneeOptions = [...result].map((x: any) => {
          return {
            label: `${x.customerCode}-${x.customerName}`,
            value: x.customerCode,
          };
        });
        this.consigneeOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });

    this.dropdownOptionService.getToCountryOptions().subscribe({
      next: (options: any[]) => {
        this.toCountryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
        this.toCountryOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.toCityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
        this.toCityOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      },
    });

    forkJoin([
      this.translateService.get('NewExport.Form.Forwarder'),
      this.translateService.get('NewExport.Form.ExportMethod'),
      this.translateService.get('NewExport.Form.PayeeType'),
      this.translateService.get('NewExport.Form.OriginCurrenAnt'),
      this.translateService.get('NewExport.Form.Payee'),
      this.translateService.get('NewExport.Form.AccountCurrenAnt'),
      this.translateService.get(`NewExport.Form${this.isHkFacility ? '.HK' : ''}.IdentificaitonNum`),
      this.translateService.get('NewExport.Form.FCAFOBPrice'),
      this.translateService.get('NewExport.Form.DeliveryMode'),
      this.translateService.get('NewExport.Form.FCAFOBPriceAccount'),
      this.translateService.get('NewExport.Form.BillComp'),
      this.translateService.get('NewExport.Form.PromotionFeeAccount'),
      this.translateService.get('NewExport.Form.CustomerCode'),
      this.translateService.get('NewExport.Form.MAWB'),
      this.translateService.get('NewExport.Form.DeclarDate'),
      this.translateService.get('NewExport.Form.HAWB'),
      this.translateService.get('NewExport.Form.DeclarType'),
      this.translateService.get('NewExport.Form.FlightNum'),
      this.translateService.get('NewExport.Form.StatisticalMethods'),
      this.translateService.get('NewExport.Form.FlightDate1'),
      this.translateService.get('NewExport.Form.FlightDate2'),
      this.translateService.get('NewExport.Form.Currency'),
      this.translateService.get('NewExport.Form.Remarks'),
      this.translateService.get('NewExport.Form.ExchangeRate'),
      this.translateService.get('NewExport.Form.DomesticForeign'),
      this.translateService.get('NewExport.Form.ChargeParty'),
      this.translateService.get('NewExport.Form.BookingNo'),
      this.translateService.get('NewExport.Form.PortOfLoadingDischargeName'),
      this.translateService.get('NewExport.Form.ToCountry'),
      this.translateService.get('NewExport.Form.ContainerNo'),
      this.translateService.get('NewExport.Form.TypeOfPackage'),
      this.translateService.get('NewExport.Form.ToCity'),
      this.translateService.get('NewExport.Form.ConsigneeCompany1'),
      this.translateService.get('NewExport.Form.ConsigneeCompany2'),
      this.translateService.get('NewExport.Form.ConsigneeAddress1'),
      this.translateService.get('NewExport.Form.ConsigneeAddress2'),
      this.translateService.get('NewExport.Form.LetterOrgId'),
      this.translateService.get('NewExport.Form.CreationTime'),
      this.translateService.get('NewExport.Form.Creator'),
      this.translateService.get('NewExport.Form.EditTime'),
      this.translateService.get('NewExport.Form.UpdateBy'),
    ]).subscribe(([
      bookingForwarder,
      exportType,
      billObjectType,
      exportAmount,
      billObject,
      exportNtdAmount,
      docNo,
      freeOnBoardAmount,
      shipMethod,
      freeOnBoardNtdAmount,
      orgId,
      freeOnBoardChargeAmount,
      consigneeKey,
      mawbNo,
      exportDtTimeZone,
      expressBill,
      docType,
      flyNo,
      docType1,
      flyDt,
      currency,
      reference,
      exchangeRate,
      exportCode,
      changeConsigneeId,
      bookingNo,
      portOfLoadingDischargeName,
      toCountry,
      containerNo,
      typeOfPackage,
      toCity,
      consigneeCompany1,
      consigneeCompany2,
      consigneeAddress1,
      consigneeAddress2,
      letterOrgId,
      createDt,
      createUser,
      updateDt,
      updateUser
    ]) => {
      this.columnNameMapping['bookingForwarder'] = bookingForwarder;
      this.columnNameMapping['exportType'] = exportType;
      this.columnNameMapping['billObjectType'] = billObjectType;
      this.columnNameMapping['exportAmount'] = exportAmount;
      this.columnNameMapping['billObject'] = billObject;
      this.columnNameMapping['exportNtdAmount'] = exportNtdAmount;
      this.columnNameMapping['docNo'] = docNo;
      this.columnNameMapping['freeOnBoardAmount'] = freeOnBoardAmount;
      this.columnNameMapping['shipMethod'] = shipMethod;
      this.columnNameMapping['freeOnBoardNtdAmount'] = freeOnBoardNtdAmount;
      this.columnNameMapping['orgId'] = orgId;
      this.columnNameMapping['freeOnBoardChargeAmount'] = freeOnBoardChargeAmount;
      this.columnNameMapping['consigneeKey'] = consigneeKey;
      this.columnNameMapping['mawbNo'] = mawbNo;
      this.columnNameMapping['exportDtTimeZone'] = exportDtTimeZone;
      this.columnNameMapping['expressBill'] = expressBill;
      this.columnNameMapping['docType'] = docType;
      this.columnNameMapping['flyNo1'] = `${flyNo}1`;
      this.columnNameMapping['flyNo2'] = `${flyNo}2`;
      this.columnNameMapping['docType1'] = docType1;
      this.columnNameMapping['flyDt'] = flyDt;
      this.columnNameMapping['currency'] = currency;
      this.columnNameMapping['reference'] = reference;
      this.columnNameMapping['exchangeRate'] = exchangeRate;
      this.columnNameMapping['exportCode'] = exportCode;
      this.columnNameMapping['changeConsigneeId'] = changeConsigneeId;
      this.columnNameMapping['bookingNo'] = bookingNo;
      this.columnNameMapping['portOfLoadingDischargeName'] = portOfLoadingDischargeName;
      this.columnNameMapping['toCountry'] = toCountry;
      this.columnNameMapping['containerNo'] = containerNo;
      this.columnNameMapping['typeOfPackage'] = typeOfPackage;
      this.columnNameMapping['toCity'] = toCity;
      this.columnNameMapping['consigneeCompany1'] = consigneeCompany1;
      this.columnNameMapping['consigneeCompany2'] = consigneeCompany2;
      this.columnNameMapping['consigneeAddress1'] = consigneeAddress1;
      this.columnNameMapping['consigneeAddress2'] = consigneeAddress2;
      this.columnNameMapping['letterOrgId'] = letterOrgId;
      this.columnNameMapping['createDt'] = createDt;
      this.columnNameMapping['createUser'] = createUser;
      this.columnNameMapping['updateDt'] = updateDt;
      this.columnNameMapping['updateUser'] = updateUser;
    });

        // 當 shipMethod 變更時，重新驗證 flyNo1
    this.addForm.get('shipMethod')?.valueChanges.subscribe(() => {
      this.addForm.get('flyNo1')?.updateValueAndValidity();
    });
  }

  orgChange(event: any): void{
    this.exportHeader.billObject = '76';
  }

  saveBtn(event: any): void{
    this.submitted = true;

    const controls = this.addForm.controls;
    const errors : string[] = [];
    for (const column in controls) {
      const control = controls[column];
      if (!control?.errors) {
        continue;
      }
      if (!control.errors.maxlength) {
        continue;
      }
      errors.push(`${this.columnNameMapping[column]}: ${control.errors.maxlength.actualLength}/${control.errors.maxlength.requiredLength}`);
    }
    if (errors.length > 0) {
      this.toastService.error(`超越欄位長度限制錯誤，請修正後再儲存。\n${errors.join('\n')}`);
      return;
    }

    if (this.addForm.invalid) {
      //請檢查是否有必填欄位尚未填寫 需再修改json來源 from NewExport
      this.translateService.get('ExportDeclarationQuery.Alert.CheckRequiredFields')
      .subscribe({
        next: result => {
          this.toastService.warn(result);
        }
      });
      return;
    }

    var docNo2 = this.exportHeader.docNo2;
    if(docNo2 === null ||  docNo2 === '')
      docNo2 = '  ';

    this.exportHeader.docNo = `${this.exportHeader.docNo1}/${docNo2}/${this.exportHeader.docNo3}/${this.exportHeader.docNo4}/${this.exportHeader.docNo5}`;
    if (this.isHkFacility) {
      this.exportHeader.docNo = this.exportHeader.docNo1;
    }
    this.exportHeader.exportDt = isNullOrEmpty(this.exportHeader.exportDtTimeZone) ? null : new Date(this.exportHeader.exportDtTimeZone).toISOString();
    this.exportHeader.flyDt1 = isNullOrEmpty(this.exportHeader.flyDt1TimeZone) ? null : new Date(this.exportHeader.flyDt1TimeZone).toISOString();
    this.exportHeader.flyDt2 = isNullOrEmpty(this.exportHeader.flyDt2TimeZone) ? null : new Date(this.exportHeader.flyDt2TimeZone).toISOString();
    this.exportHeader.updateUser = this.userProfile.userName;
    this.exportHeader.createUser = this.userProfile.userName;
    this.exportHeader.facility = this.laasSetting.facility;

    var consigneeName = this.consigneeDic.filter((x: any) => {
      return x.customerCode == this.exportHeader.consigneeKey;
    }).map((x: any) => {
      return x.customerName;
    });

    if(consigneeName.length > 0){
      this.exportHeader.consigneeName = consigneeName[0];
    }

    var changeConsigneeName = this.consigneeDic.filter((x: any) => {
      return x.customerCode == this.exportHeader.changeConsigneeId;
    }).map((x: any) => {
      return x.customerName;
    });

    if(changeConsigneeName.length > 0){
      this.exportHeader.changeConsigneeName = changeConsigneeName[0];
    }
    this.exportService.addExport(this.exportHeader).subscribe({
      next: result => {
        this.translateService.get('Common.Message.SuccessSave')
            .subscribe({
              next: msg => {
                this.toastService.success(msg);
                this.routeStateService.navigateTo('/TransportOperation/ExportSearch', result);
              }
            });
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    })
  }

  docTypeChange(event: any): void{
    var docType = this.exportHeader.docType;

    var docType1Value = "";
    var docType1ValueArr = this.docType1Dic.filter((x: any) => {
      return x.optionCode.startsWith(docType);
    }).map((x: any) => {
      return x.optionCode;
    });
    if(docType1ValueArr.length > 0){
      docType1Value = docType1ValueArr[0];
    }

    if(docType == "G5"){
      this.exportHeader.exportCode = "1";
      this.addForm.controls.docType1.setValue("G502");
    }else if(docType == "G3"){
      this.exportHeader.exportCode = "2";
      this.addForm.controls.docType1.setValue("G381");
    }else{
      this.exportHeader.exportCode = "";
      this.addForm.controls.docType1.setValue(docType1Value);
    }

    this.changeDocType1Options();
  }

  changeDocType1Options(): void{
    this.docType1Options = [...this.docType1Dic].filter((x: any) => {
      return x.optionCode.startsWith(this.exportHeader.docType);
    }).map((x: any) => {
      return {
        label: `${x.optionCode}-${x.optionDesc}`,
        value: x.optionCode,
      };
    });

    this.docType1Options.unshift({
      label: '請選擇',
      value: '',
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.addForm.controls; }

  private handleString(str: any): string{
    var result ="";

    if(str){
      result = str;
    }

    return result;
  }

  changeBillObject(): void {
    const billObjectType = this.exportHeader.billObjectType;

    this.facilityService.getBillObjectOptions(this.laasSetting.facility, billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.billObjectOptions.unshift({
          label: this.transLabel,
          value: ""
        });
      }
    });
  }

  dateOnChange(date: any,type:string) {
    switch (type) {
      case "exportDtTimeZone" :
        this.exportHeader.exportDtTimeZone = date.date;
        this.addForm.controls.exportDtTimeZone.setValue(date.date);
        break;
      case "flyDt1TimeZone" :
        this.exportHeader.flyDt1TimeZone = date.date;
        break;
      case "flyDt2TimeZone" :
        this.exportHeader.flyDt2TimeZone = date.date;
        break;
    }
  }
}
